<div class="wrapper">
    <div class="overlay" *ngIf="active">

    </div>
    <ng-content></ng-content>
</div>